/** Same length the backend hands out. People type what they see on the invite, spaces and all. */
export const INVITE_CODE_LENGTH = 8;

/** Upper case, no spaces or dashes, never longer than a code. Mirrors the server's own rule. */
export const normalizeInviteCode = (input: string): string =>
  input
    .toUpperCase()
    .replaceAll(/[^A-Z0-9]/g, "")
    .slice(0, INVITE_CODE_LENGTH);

/** "K7MQ 2XRA": the code as invites print it, while the person types. */
export const displayInviteCode = (code: string): string =>
  code.length > 4 ? `${code.slice(0, 4)} ${code.slice(4)}` : code;

/** The page the invite email links to. Also where sign-in sends someone who arrived with a code. */
export const joinPathOf = (code: string) => `/join?code=${encodeURIComponent(code)}`;
